export function extractFeatureDescriptions(metafieldsMap): string[] {
    return Array.from({ length: 7 }, (_, index) => {
        const key = `custom.feature_image_${index + 1}`;
        return metafieldsMap[key] || '';
    });
}
